import { render, staticRenderFns } from "./videoListMore.vue?vue&type=template&id=10ce169e&scoped=true&"
import script from "./videoListMore.vue?vue&type=script&lang=js&"
export * from "./videoListMore.vue?vue&type=script&lang=js&"
import style0 from "./videoListMore.vue?vue&type=style&index=0&id=10ce169e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce169e",
  null
  
)

export default component.exports